import { render, staticRenderFns } from "./CollectForm.vue?vue&type=template&id=942c215e&scoped=true"
import script from "./CollectForm.vue?vue&type=script&lang=js"
export * from "./CollectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942c215e",
  null
  
)

export default component.exports